const translations = {
  "en": {
    "Estimated": "Estimated",
    "Fiscal Period": "Fiscal Period",
    "Reported": "Reported",
    "Result": "Result",
    "Surprise": "Surprise"
  },
  "zh-tw": {
    "Estimated": "預估",
    "Fiscal Period": "財報週期",
    "Reported": "已公佈",
    "Result": "結果",
    "Surprise": "預期差"
  }
};

export default translations;
